import { BfxBlotterOrdersContextMenuItem } from "./BfxBlotterOrdersContextMenuItem";
import { BfxBlotterOrdersContextMenuState } from "./BfxBlotterOrdersContextMenuState";

import { BfxBlotterAction } from "../bfx-base-blotter/BfxBlotterAction";

import { ContextMenuItemState } from "../ContextMenuItemState";
import { ContextMenuItemStateCommandCriteria } from "../ContextMenuItemStateCommandCriteria";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  OrderPauseState,
  PausableOrderType,
} from "shared/cubiq-services/model/orders/OrderPauseState";

export class BfxBlotterOrdersContextMenuPauseItem extends BfxBlotterOrdersContextMenuItem {
  constructor() {
    super(
      BfxBlotterAction.ACTION_ORDER_PAUSE,
      "Pause",
      checkPauseResumeAvailable,
      createPauseResumeEnabledFn(OrderPauseState.isPausableOrder),
      ContextMenuItemStateCommandCriteria.Item,
      ContextMenuItemStateCommandCriteria.Item,
    );
  }

  public reset(): void {
    let oldState = this.state;
    this.state = new ContextMenuItemState();
    this.state.title = oldState.title;
  }
}

/**
 * Common function shared between Pause and resume that test to see if operations should be avilable.
 * @param menuState
 * @param itemState
 * @param item
 */
export function checkPauseResumeAvailable(
  menuState: BfxBlotterOrdersContextMenuState,
  itemState: ContextMenuItemState,
  item: CubiqTS.OrderDataImpl,
) {
  const orderType = item?.orderType;
  const isPauseType = OrderPauseState.isPausableOrderType(orderType);

  itemState.available = isPauseType && menuState.canPauseResume;
}

/**
 * Common Pause/resume Factory function that returns a function to determine if Pause/Resume is available for specified item
 * and also that the input item matches the Pause/REsume operation test - which either tests for pausable or resumable
 * @param pauseResumeOperationTest
 * @returns
 */
export function createPauseResumeEnabledFn(pauseResumeOperationTest: (any) => boolean) {
  return function (
    this: void,
    menuState: BfxBlotterOrdersContextMenuState,
    itemState: ContextMenuItemState,
    item: CubiqTS.OrderDataImpl,
  ) {
    // if we have a limit order - we need to disable the item
    if (itemState.count === -1) {
      // NOP = we had one we can't use  - so we are done.
    } else {
      let candidate = false;
      let canPauseResume = false;

      if (item && item.deskId != null) {
        const pauseType = OrderPauseState.getPausableOrderType(item.orderType);
        let tradingGroup = menuState.traderGroups.get(item.deskId.toString());
        if (!tradingGroup || pauseType === PausableOrderType.NONE) {
          // Nope, no trading group or order is not of a puasable type
          candidate = false;
        } else if (item.lockType != null) {
          // Nope, order is locked
          candidate = false;
        } else {
          let isPausableGroup;
          switch (pauseType) {
            case PausableOrderType.ALGO:
              isPausableGroup = tradingGroup.pauseResumeFg;
              break;
            case PausableOrderType.LIMIT:
              // Basically, test for first 5 types from TradingGroupImplBuilder but EOMS must have Pause/resume
              isPausableGroup =
                !tradingGroup.isBenchmarkFg &&
                !tradingGroup.isStagingFg &&
                (!(tradingGroup.isAutoFilledFg && tradingGroup.isExternallyFilledFg) ||
                  tradingGroup.pauseResumeFg);
              break;
          }
          if (!isPausableGroup) {
            // Nope, group is not pausable
            candidate = false;
          } else {
            candidate = true;

            if (
              pauseType == PausableOrderType.LIMIT &&
              (item.orderType == CubiqTS.OrderType.MARKET ||
                item.orderType == CubiqTS.OrderType.MARKET_FOK ||
                item.orderType == CubiqTS.OrderType.MARKET_IOC)
            ) {
              // For Market ordedrs, allow them to pass through but they do no incrment the available count
              canPauseResume = false;
            } else if (pauseResumeOperationTest(item)) {
              canPauseResume = true;
            }
          }
        }
      }
      if (!candidate) {
        // As this item is not a candidate, disabled for everything
        itemState.count = -1;
      } else if (canPauseResume) {
        itemState.count++;
      }
    }
    itemState.enabled = itemState.count > 0; // if any were enabled - then the menu item should be.
  };
}
